import workspaceControllers from "../../components/canvas/store/workspaceControllers";

export class CrownMoldingPositions {
  static prepareCrownMoldingPositions() {
    const crownMoldings = workspaceControllers.crownMolding.getCrownMoldings();

    return crownMoldings.map(crownMolding => {
      return {
        "texture_url": "https://qc-3dfiles.s3.amazonaws.com/ar-textures/Absolute White - MSI - Marble - color - 1 - 0.16 - 0.33.png",
        "edge_url": crownMolding.feature3dUrl ? crownMolding.feature3dUrl : 'https://quotecountertops.com/video/3d/crownmolding/Crown%20Molding_CoveCrown.glb',
        "height": crownMolding.height,
        "posY": crownMolding.posY,
        "contour_points": crownMolding.contour_points,
        "cabinet_position": crownMolding.cabinet_position,
        "attached_to_shape_id": crownMolding.shapeId,
      }
    })
  }
  static prepareCrownMoldingPositionsForTheShape(shapeId) {
    const crownMoldings = workspaceControllers.crownMolding.getCrownMoldingForShape(shapeId);

    return crownMoldings.map(crownMolding => {
      return {
        "texture_url": "https://qc-3dfiles.s3.amazonaws.com/ar-textures/Absolute White - MSI - Marble - color - 1 - 0.16 - 0.33.png",
        "edge_url": crownMolding.feature3dUrl ? crownMolding.feature3dUrl : 'https://quotecountertops.com/video/3d/crownmolding/Crown%20Molding_CoveCrown.glb',
        "height": crownMolding.height,
        "posY": crownMolding.posY,
        "contour_points": crownMolding.contour_points,
        "cabinet_position": crownMolding.cabinet_position,
        "attached_to_shape_id": crownMolding.shapeId,
      }
    })
  }
}
